import { z } from "zod";
import { DateTypeSchema, SourceTypeSchema } from "./core.schema";
import { BaseFirestoreSchema } from "./firestore.schema";

// Schemas

export const AccountIndexDocumentSchema = z.object({
  _source: SourceTypeSchema,
  emails: z.string().array(),
});

export const AccountSchema = BaseFirestoreSchema.extend({
  name: z.string().optional(),
  email: z.string().email(),
  emailVerified: z.boolean().nullable(),
  image: z.string().nullable().optional(),
  lastLoginTime: DateTypeSchema,
  firstName: z.string(),
  lastName: z.string(),
});

// DTOs

export const CreateAccountDtoSchema = AccountSchema.partial().and(
  AccountSchema.required().pick({
    email: true,
    firstName: true,
    lastName: true,
  })
);

export const PutAccountDtoSchema = CreateAccountDtoSchema;

export const PatchAccountDtoSchema = AccountSchema.partial();
